export enum QueryStates {
  Error,
  Loading,
  Complete,
}
